import React, { Component } from 'react';
import { Bling as GPT } from 'react-gpt';

import TeachersHeader from 'Components/TeachersHeader';
import GenericText from 'Components/GenericText';
import RampUnit from '../utils/Playwire/RampUnit';
import DocumentHeadFields from 'Components/DocumentHeadFields';

class TeachersLanding extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLoading: true,
    };
  }

  render() {
    const { adTargeting } = this.state;
    return (
      <main>
        <DocumentHeadFields documentTitle={`Teachers and Parents`} />
        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>
        <div className="Page__ContentWrapper">
          <div className="Page__container Page__container--split-layout Page__container--main">
            <TeachersHeader />
            <section className="ContentBlock">
              <div className="ContentBlock__content">
                <GenericText contentId="teachersLanding" />
              </div>
            </section>
            <aside className="ContentBlock__aside">
              <RampUnit type="med_rect_atf" id="siderec" />
              <RampUnit type="med_rect_btf" id="sideflex" />
            </aside>
          </div>
        </div>
      </main>
    );
  }
}

export default TeachersLanding;
